export default __webpack_public_path__ + "static/media/map-ubicacion-halo.b4069f9b.svg";